module.exports = __webpack_public_path__ + "img/company30.4e827b49.png";